var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _g4, _g5, _g6, _path18, _path19, _g7, _path20, _path21, _path22, _path23, _g8, _path24, _path25, _path26, _g9, _g10, _path27, _path28, _path29, _path30, _g11, _path31, _g12, _path32, _g13, _path33, _path34, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagerBurned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 415,
    height: 737.451,
    viewBox: "0 0 415 737.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-burned",
    x1: 32.66,
    y1: 7.38,
    x2: 32.66,
    y2: 7.361,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faad25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef5714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-burned-2",
    x1: 44.797,
    y1: 9.912,
    x2: 44.797,
    y2: 9.886,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd13c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89e20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-burned-3",
    x1: 33.104,
    y1: 7.554,
    x2: 33.104,
    y2: 7.535,
    xlinkHref: "#linear-gradient-burned"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-burned-4",
    x1: 45.918,
    y1: 9.767,
    x2: 45.918,
    y2: 9.74,
    xlinkHref: "#linear-gradient-burned-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "manager-burned",
    transform: "translate(2261.884 -290.545)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "fire",
    transform: "translate(-2203.55 360.219)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87592",
    "data-name": "Group 87592",
    transform: "translate(74.479 2.812)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_160428",
    "data-name": "Path 160428",
    d: "M-2127.353,500.472s23.625-5.367,39.674-24.494c18.35-21.872,8.738-46.366,17.474-60.49,0,0-9.028-.9-12.232,16.871a86.4,86.4,0,0,0-.856-29.535,25.728,25.728,0,0,1,3.2-17.646c-4.883,1.345-8.729,5.91-9.957,11.812-1.677,7.5-2.93,12.84-5.706,12.84s-5.087-23.341.055-34.843,4.729-31.745-4.936-47.245-7.812-24-7.812-24a30.331,30.331,0,0,0-1.849,21.5c3.288,12.746-2.264,28.5-11.718,33.248a54.143,54.143,0,0,0,2.263-44.745c-4.869-14.83-15.516-25.713-28.369-28.993a39.4,39.4,0,0,1,7.812,25.745c0,17.5-12.54,24.994-12.54,44.493,0,0-4.315-.75-5.55-19.495s-5.972-20.5-5.972-20.5a31.718,31.718,0,0,1-4.112,20.245c-6.395,10.375-11.228,13-8.842,48.744-7.729-19.121-3.414-32.872-19.119-38.183a55.89,55.89,0,0,1,4.78,34.3c-3.547,19.495-7.709,31.683,3.548,46.5-5.56.727-10.819-3.206-12.8-9.564,0,0-1.083,83.427,73.544,83.427Z",
    transform: "translate(2200.918 -284.751)",
    fill: "url(#linear-gradient-burned)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160429",
    "data-name": "Path 160429",
    d: "M-2113.158,493.169a65.553,65.553,0,0,0,31.66-19.546c14.643-17.451,6.969-37,13.942-48.269,0,0-7.2-.722-9.762,13.461a68.939,68.939,0,0,0-.682-23.567,20.534,20.534,0,0,1,2.552-14.067c-3.893,1.078-6.958,4.719-7.937,9.424-1.339,5.986-2.336,10.25-4.553,10.25s-4.059-18.626.041-27.8c4.487-12.489,2.975-26.965-3.936-37.7-7.71-12.368-6.231-19.148-6.231-19.148a24.2,24.2,0,0,0-1.494,17.156c2.541,10.428-1.388,21.576-9.35,26.531a43.2,43.2,0,0,0,1.8-35.706c-3.884-11.836-12.383-20.525-22.64-23.142a31.45,31.45,0,0,1,6.231,20.548c0,13.961-10,19.965-10,35.505,0,0-3.445-.6-4.431-15.559s-4.757-16.335-4.757-16.335a25.3,25.3,0,0,1-3.281,16.157c-5.1,8.277-8.954,10.372-7.052,38.894-6.168-15.259-2.723-26.229-15.255-30.469a44.613,44.613,0,0,1,3.814,27.375c-2.829,15.559-6.15,25.282,2.829,37.1-4.435.576-8.631-2.561-10.214-7.633,0,0-.862,66.573,58.688,66.573Z",
    transform: "translate(2219.676 -267.478)",
    fill: "url(#linear-gradient-burned-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87592-2",
    "data-name": "Group 87592",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160428-2",
    "data-name": "Path 160428",
    d: "M-2157.111,482.082s23.625-5.368,39.674-24.5c18.348-21.87,8.738-46.366,17.472-60.49,0,0-9.026-.9-12.232,16.871a86.387,86.387,0,0,0-.856-29.533,25.75,25.75,0,0,1,3.2-17.648c-4.882,1.345-8.73,5.91-9.955,11.812-1.677,7.5-2.932,12.84-5.706,12.84s-5.087-23.339.054-34.841,4.729-31.747-4.936-47.247-7.813-24-7.813-24a30.324,30.324,0,0,0-1.847,21.5c3.288,12.748-2.264,28.5-11.72,33.248a54.131,54.131,0,0,0,2.263-44.743c-4.867-14.832-15.516-25.715-28.367-28.995a39.415,39.415,0,0,1,7.812,25.745c0,17.5-12.54,25-12.54,44.5,0,0-4.315-.75-5.55-19.495s-5.974-20.5-5.974-20.5a31.711,31.711,0,0,1-4.111,20.245c-6.4,10.375-11.228,13-8.842,48.742-7.729-19.119-3.414-32.872-19.119-38.181a55.916,55.916,0,0,1,4.78,34.3c-3.548,19.495-7.709,31.681,3.548,46.494-5.56.727-10.819-3.2-12.8-9.564,0,0-1.081,83.429,73.546,83.429Z",
    transform: "translate(2230.678 -266.359)",
    fill: "url(#linear-gradient-burned-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160429-2",
    "data-name": "Path 160429",
    d: "M-2163.5,514.508c12.492-3.233,24.071-10.383,33.588-20.738,15.535-18.515,7.4-39.261,14.8-51.213,0,0-7.643-.766-10.357,14.282a73.107,73.107,0,0,0-.726-25,21.8,21.8,0,0,1,2.71-14.924c-4.131,1.144-7.385,5.007-8.421,10-1.423,6.348-2.478,10.873-4.83,10.873s-4.31-19.762.043-29.5c4.759-13.251,3.154-28.61-4.178-40-8.178-13.122-6.611-20.316-6.611-20.316a25.683,25.683,0,0,0-1.583,18.2c2.693,11.064-1.476,22.892-9.923,28.149a45.815,45.815,0,0,0,1.912-37.883c-4.121-12.559-13.136-21.777-24.018-24.551a33.394,33.394,0,0,1,6.61,21.8c0,14.812-10.615,21.182-10.615,37.671,0,0-3.653-.635-4.7-16.508s-5.05-17.331-5.05-17.331a26.851,26.851,0,0,1-3.479,17.143c-5.417,8.781-9.5,11-7.482,41.266-6.544-16.19-2.891-27.829-16.185-32.327a47.337,47.337,0,0,1,4.045,29.044c-3,16.507-6.523,26.824,3,39.361-4.706.611-9.156-2.717-10.834-8.1,0,0-.915,70.636,62.264,70.636Z",
    transform: "translate(2235.805 -274.315)",
    fill: "url(#linear-gradient-burned-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pose-1",
    transform: "translate(-2261.884 290.545)",
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161449",
    "data-name": "Path 161449",
    d: "M-2193.052,377.2l-2.4,11.988-8.837-1.361-.623-5.392,1.661-2.434,3.53-1.481,3.088-.979Z",
    transform: "translate(2318.929 -203.774)",
    fill: "#6a707b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161450",
    "data-name": "Path 161450",
    d: "M-2200.43,427.527l4.671-23.257,2.337-23.315-1.4-15.384,21.96-24.27h33.021s9.344,12.056,10.905,16.339,4.36,12.054,8.1,15.7,29.747,43.3,30.525,55.989a111.658,111.658,0,0,1,.088,18.184s-11.147,16.307-21.114,20.632-13.226,5.774-13.226,5.774-10.761.654-11.073,0-10.591-7-12.771-9.854-22.117-11.736-24.142-13.957S-2200.43,427.527-2200.43,427.527Z",
    transform: "translate(2323.419 -239.723)",
    fill: "#f0ab7e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161451",
    "data-name": "Path 161451",
    d: "M-2090.227,447.519s.14-1.137.224-3.534c-14.109,23.844-41.427,8.668-41.427,8.668-13.705.474-41.273-16.975-45.012-22.843s-8.255-48.432-3.374-52.034,1.141-14.061,1.815-19.773,11.473-9.5,11.473-9.5-1.909-3.2-4.481-7.2h-1.853l-21.96,24.27,1.4,15.384-2.337,23.317-4.671,23.255s25.854,20.363,27.878,22.583,21.963,11.1,24.142,13.957,12.462,9.206,12.771,9.854,11.073,0,11.073,0,3.256-1.443,13.226-5.774S-2090.227,447.519-2090.227,447.519Z",
    transform: "translate(2323.42 -239.725)",
    fill: "#e49f71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161452",
    "data-name": "Path 161452",
    d: "M-2096.013,409.762s.08-1.109,3.871.634,27.2,16.01,26.656,18.716-6.148,5.077-6.148,5.077-8.206-.953-9.657-2.167-8.1-2.486-9.448-5.129-4-6.979-4.05-7.191-.889-2.644-1.223-3.382A39.908,39.908,0,0,1-2096.013,409.762Z",
    transform: "translate(2427.837 -171.52)",
    fill: "#dfe3e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87703",
    "data-name": "Group 87703",
    transform: "translate(325.582 196.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161453",
    "data-name": "Path 161453",
    d: "M-2092.525,406.322s.058-.837,2.926.48,20.566,12.114,20.155,14.153-4.649,3.837-4.649,3.837-6.2-.718-7.3-1.637-6.124-1.879-7.145-3.879-3.022-5.277-3.062-5.438-.672-2-.925-2.558A32.335,32.335,0,0,1-2092.525,406.322Z",
    transform: "translate(2105.788 -371.437)",
    fill: "#7b7d8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161454",
    "data-name": "Path 161454",
    d: "M-2020.171,410.114c3.746-8.291,6.074-20.964,2.2-20.964s-13.541,21.138-13.541,21.138h0l-.482.026c2.912-11.968,3.082-20.119-.458-19.613-3.572.51-7.9,11.341-8.757,20.323a40.792,40.792,0,0,0-10.667,2.135c-6.284,2.894-14.96-1.523-14.96-1.523,3.591-8.836-8.375-10.207-8.375-10.207,1.5,7.923-7.181,10.665-10.475,12.646s-2.093,4.569-1.345,9.748a4.412,4.412,0,0,1-3.206,5.356,4.321,4.321,0,0,1-.833.128l-1.945,2.742,14.66,10.055s3.59-8.075,6.732-10.511,21.988-2.44,27.972-2.288,6.133-3.5,6.133-3.5C-2024.661,423.823-2020.68,411.237-2020.171,410.114Z",
    transform: "translate(2105.393 -388.37)",
    fill: "#e7b89a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161455",
    "data-name": "Path 161455",
    d: "M-2041.764,388.764c-4.8.252-5.654,8.177-7.383,21.1a8.127,8.127,0,0,1-2.734,3.684c-6.284,2.892-14.959-1.523-14.959-1.523,1.671-4.111-.288-10.115-2.013-12.238-1.261-1.551-5.99-3.2-7.273-2.424-1.185.708.911,4.457.911,4.457,1.5,7.923-7.181,10.665-10.475,12.644s-2.094,4.571-1.345,9.748a4.413,4.413,0,0,1-3.206,5.358,4.167,4.167,0,0,1-.833.126l-1.945,2.742,6.428,4.4a18.532,18.532,0,0,0,8.186-5.323c5.16-5.6,5.273-7.541,13.238-8.341s21.244,4.6,23.364-3.849a41.385,41.385,0,0,0,1.357-8.349c.4-2.954.432-4.649.492-5.67C-2039.7,400.92-2036.852,388.512-2041.764,388.764Z",
    transform: "translate(2105.388 -388.76)",
    fill: "#bf8973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161456",
    "data-name": "Path 161456",
    d: "M-2064.434,421.4c3.418-1.293,9.548-4.3,12.154-10.471a114.2,114.2,0,0,0,5.682-21.774c-3.652.162-10.343,14.029-13.541,21.138Z",
    transform: "translate(2134.011 -388.37)",
    fill: "#bf8973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161457",
    "data-name": "Path 161457",
    d: "M-2066.535,442.179a98.8,98.8,0,0,0,3.678-21.354s-18.612-2.88-23.081-14.634a100.849,100.849,0,0,1-13.262,21.036C-2088.465,432.566-2077.636,437.654-2066.535,442.179Z",
    transform: "translate(2099.2 -371.306)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161458",
    "data-name": "Path 161458",
    d: "M-2091.213,431.14a218.741,218.741,0,0,1,5.632-24.112c-.122-.274-.25-.55-.356-.839a100.846,100.846,0,0,1-13.262,21.036Q-2095.217,429.21-2091.213,431.14Z",
    transform: "translate(2099.2 -371.307)",
    fill: "#7b7d8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161459",
    "data-name": "Path 161459",
    d: "M-2079.759,406.286c-2.8,1.487-7.741,4.343-7.181,8.806,0,0,4.377-6.512,9.648-6.854s14.249,1.029,17.165,2.97,8.077,2.514,12.678-8.568-5.275,8.253-10.449,8.005C-2069.013,406.746-2076.95,404.8-2079.759,406.286Z",
    transform: "translate(2111.433 -378.298)",
    fill: "#916c54"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87704",
    "data-name": "Group 87704",
    transform: "translate(238.995 212.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161460",
    "data-name": "Path 161460",
    d: "M-2142.465,396.6s15.574,1.269,23.986,14.908,29.593,40.607,34.267,43.46,10.278,10.151,10.278,10.151-21.494,33.622-22.427,33.622-20.247-37.118-20.872-38.071-10.279-36.164-11.208-36.48-14.009-11.421-14.009-11.421Z",
    transform: "translate(2142.465 -396.596)",
    fill: "#e2ebf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161461",
    "data-name": "Path 161461",
    d: "M-2084.212,454.964c-4.674-2.854-25.855-29.82-34.267-43.461s-23.986-14.906-23.986-14.906v5.089l8.75-.961s10.748,3.122,14.8,12.688,21.182,31.773,26.321,37.164,13.4,7.457,15.73,11.582c.285.5.57.616.851.436A40.949,40.949,0,0,0-2084.212,454.964Z",
    transform: "translate(2142.465 -396.594)",
    fill: "#fff"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161462",
    "data-name": "Path 161462",
    d: "M-2099.913,429.132a7.7,7.7,0,0,0-6.988,2.882c-2.284,3.49-12.877,4.969-12.877,4.969s.1,11.421,0,11.74,21.815-.845,22.117-1.271,5.6-9.406,5.6-9.832S-2099.913,429.132-2099.913,429.132Z",
    transform: "translate(2404.177 -151.834)",
    fill: "#abafb8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161463",
    "data-name": "Path 161463",
    d: "M-2082.667,542.509s43.923-62.177,46.415-113.564c0,0-24.616-3.8-30.528-19.351,0,0-17.446,40.921-58.562,61.859Z",
    transform: "translate(2398.605 -171.34)",
    fill: "#f0ecf5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161464",
    "data-name": "Path 161464",
    d: "M-2066.781,409.594s-17.446,40.921-58.562,61.859l42.676,71.057s3.75-5.306,9.118-14.1c-10.1-47.057.212-93.962,7.241-117.711C-2066.473,410.335-2066.637,409.968-2066.781,409.594Z",
    transform: "translate(2398.605 -171.34)",
    fill: "#dfe3e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161465",
    "data-name": "Path 161465",
    d: "M-2149.2,384.814l71.179,51.312,17.729-12.638-.718-5.3,15.98-14.247c17.755,4.125,17.317,9.1,20.433,16.083s19.936,37.751,29.281,50.757,32.085,63.127,38.315,99.925-18.69,121.816-18.69,121.816c-157.622,51.392-232.382-6.878-232.382-6.878l5.918-131.434s-11.526,9.834-34.889-4.951,8.405-85.14,11.207-89.739,12.772-23.634,19.315-36.64,12.608-12.846,16.353-15.226,40.963-22.841,40.963-22.841",
    transform: "translate(2278.224 -196.153)",
    fill: "#e2ebf2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161466",
    "data-name": "Path 161466",
    d: "M-1982.484,535.631a246.414,246.414,0,0,0,3.988-40.793c-9.934,8.326-29.649,19.469-66.407,23.629-61.677,6.979-97.91-41.861-97.91-41.861s-8.312,19.341-40.707,22.195-25.235-25.379-25.235-25.379-14.884,28.661-14.341,28.987-.3,14.478,1.571,20.5,5.918,12.054,12.1,22.523,27.464,12.058,31.2,14.912,78.5,11.417,159.179-9.518C-2002.631,546.566-1990.85,541.307-1982.484,535.631Z",
    transform: "translate(2300.709 -107.428)",
    fill: "#cbd9e3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161467",
    "data-name": "Path 161467",
    d: "M-2082.907,411.339s-56.693,7.191-78.5,21.784c0,0,24.92,107.22,18.065,139.894,0,0-4.983,6.82-26.017,1.111s-43.765-10.149-42.986-19.03,20.442-32.163,44.332-42.968l-55.16,17.411-1.5,33.178,52.977,31.561,96.565-8.249s-63.857-2.221-64.17-10.785-1.1-51.075-10.05-94.862l-9.576-46.154S-2137,420.647-2082.907,411.339Z",
    transform: "translate(2299.151 -169.593)",
    fill: "#95989e"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87705",
    "data-name": "Group 87705",
    transform: "translate(240.402 212.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161468",
    "data-name": "Path 161468",
    d: "M-2099.258,458.969c-9.346-13.009-26.167-43.779-29.281-50.757-2.656-5.948-2.377-8.44-13.223-11.6,1,.306,8.259,2.886,12.12,14.289,4.152,12.268,20.351,42.508,27.618,50.547,6.528,7.219,29.155,52.118,37.225,80.01C-2073.75,507.785-2091.327,470.006-2099.258,458.969Z",
    transform: "translate(2141.762 -396.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161469",
    "data-name": "Path 161469",
    d: "M-2102.206,473.521c.091.462.185.869.277,1.237C-2102,474.34-2102.113,473.939-2102.206,473.521Z",
    transform: "translate(2181.371 -319.606)",
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161470",
    "data-name": "Path 161470",
    d: "M-2172.417,450.715s-29.043,3.516-59.039-22.367c-9.006,21.986-23.5,65.987-5.591,77.323a62.974,62.974,0,0,0,9.9,5.179c5.768-2.918,10.089-5.179,10.089-5.179A70.8,70.8,0,0,1-2172.417,450.715Z",
    transform: "translate(2278.221 -152.562)",
    fill: "#cbd9e3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161471",
    "data-name": "Path 161471",
    d: "M-2140.478,527.844s-21.494,6.346-47.35,12.054S-2233,537.678-2238.6,525.94s11.525-58.37,25.544-69.79,14.009-35.845,15.886-45.045c1.562-7.685,14.83-15.846,19.161-18.328-6,3.35-10.915,6.12-12.152,6.906-3.738,2.38-9.806,2.221-16.353,15.228s-16.509,32.039-19.315,36.64-34.576,74.955-11.207,89.739,34.889,4.951,34.889,4.951l-.152,3.4C-2173.445,542.829-2140.478,527.844-2140.478,527.844Z",
    transform: "translate(2278.226 -188.179)",
    fill: "#abafb8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161472",
    "data-name": "Path 161472",
    d: "M-2240.914,474.746c5.7-13.551,14.3-31.092,17.526-34.721,4.457-5.019,11.421-20.247,14.537-28.176s12.148-12.056,12.148-12.056c16.509-5.816,20.558,31.188,20.558,31.188a53.127,53.127,0,0,0-13.1-36.362c-2.792,1.575-4.837,2.752-5.572,3.216-3.738,2.382-9.806,2.221-16.353,15.226s-16.509,32.039-19.315,36.64A202.84,202.84,0,0,0-2240.914,474.746Z",
    transform: "translate(2282.882 -186.335)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87707",
    "data-name": "Group 87707",
    transform: "translate(65.503 478.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87706",
    "data-name": "Group 87706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161473",
    "data-name": "Path 161473",
    d: "M-2229.154,529.879s5.815,143.812,61.47,227.549h34.889s51.5-53.295,56.487-137.89S-2229.154,529.879-2229.154,529.879Z",
    transform: "translate(2229.154 -529.879)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161474",
    "data-name": "Path 161474",
    d: "M-2195.173,643.584s-12.668,11.422-2.7,20.94c0,0,.833,5.5,1.455,5.5h18.066s1.247.847,2.491-5.287c0,0,6.438,1.141,8.308,5.327,0,0,43.4,9.983,61.264,0l-53.993-26.477Z",
    transform: "translate(2256.646 -416.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161475",
    "data-name": "Path 161475",
    d: "M-2135.043,634.738c6.23,3.172-6.646,29.185-6.646,29.185s.736-1.539,9.554-11.007,15.968-36.652,15.968-36.652-8.7-5.434-10.881-6.492-19.013-12.266-19.013-12.266-52.54,4.443-53.371,4.443q-8.655,3.762-16.9,8.377a334.568,334.568,0,0,0,28.219,67.1c4.341-8.384,8.79-21.36,14.009-30.64C-2165.987,632.413-2141.273,631.566-2135.043,634.738Z",
    transform: "translate(2241.993 -462.163)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161476",
    "data-name": "Path 161476",
    d: "M-2108.258,594.875c-1.235-.635-53.235-10.151-54.756-10.151s-28.714,1.693-29.545,1.9-14.538,6.983-15.162,6.983-8.93,5.077-8.93,5.077l-2.171,7.131c2.566,9.53,5.442,19.131,8.668,28.635,6.346,8.536,14.269,16.541,21.122,15.41,14.123-2.33,40.083-15.02,44.441-11.952s15.958,10.477,27.206,8.353c4.045-.759,9.448-5.107,14.72-10.389a233.185,233.185,0,0,0,9.586-29.585C-2099.653,601.179-2107.554,595.245-2108.258,594.875Z",
    transform: "translate(2239.499 -474.962)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161477",
    "data-name": "Path 161477",
    d: "M-2175.073,648.7s26.946,9.676,26.167,10.307S-2187.067,647.112-2175.073,648.7Z",
    transform: "translate(2280.933 -411.039)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161478",
    "data-name": "Path 161478",
    d: "M-2197.149,645.469s-3.776,5.151-3.583,9.32,1.789,6.5,3.074,5.828-1.867-4.163-.895-7.137S-2193.839,642.737-2197.149,645.469Z",
    transform: "translate(2257.607 -414.711)",
    fill: "#232323"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87709",
    "data-name": "Group 87709",
    transform: "translate(173.884 459.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87708",
    "data-name": "Group 87708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161479",
    "data-name": "Path 161479",
    d: "M-2175,520.147s5.816,143.812,61.47,227.559h34.889s51.5-53.293,56.487-137.89S-2175,520.147-2175,520.147Z",
    transform: "translate(2174.999 -520.147)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161480",
    "data-name": "Path 161480",
    d: "M-2141.02,633.849s-12.668,11.419-2.7,20.938c0,0,.831,5.5,1.455,5.5h18.066s1.247.846,2.491-5.284c0,0,6.438,1.135,8.308,5.324,0,0,43.4,9.982,61.262,0l-53.994-26.473Z",
    transform: "translate(2202.49 -406.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161481",
    "data-name": "Path 161481",
    d: "M-2080.167,629.728c6.23,3.172-6.646,29.187-6.646,29.187s.736-1.537,9.554-11.007,15.969-36.648,15.969-36.648-8.7-5.436-10.881-6.5-19-12.262-19-12.262-52.541,4.441-53.371,4.441q-8.279,3.587-16.173,7.985a309.583,309.583,0,0,0,29.053,64.3c3.853-8.241,7.851-19.271,12.456-27.448C-2111.111,627.411-2086.4,626.564-2080.167,629.728Z",
    transform: "translate(2189.299 -447.697)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161482",
    "data-name": "Path 161482",
    d: "M-2053.137,589.875c-1.233-.636-53.235-10.155-54.754-10.155s-28.717,1.693-29.549,1.905-14.538,6.98-15.158,6.98-8.93,5.073-8.93,5.073l-1.933,6.36c3.122,10.821,6.656,21.668,10.659,32.3,5.912,7.361,12.82,13.531,18.895,12.53,14.124-2.326,40.08-15.01,44.445-11.948s15.957,10.477,27.2,8.351a14.242,14.242,0,0,0,4.525-1.917,237.842,237.842,0,0,0,15.875-41.075C-2047.315,594.091-2052.565,590.169-2053.137,589.875Z",
    transform: "translate(2186.552 -460.496)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161483",
    "data-name": "Path 161483",
    d: "M-2120.918,638.968s26.946,9.674,26.165,10.313S-2132.912,637.38-2120.918,638.968Z",
    transform: "translate(2226.777 -401.31)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161484",
    "data-name": "Path 161484",
    d: "M-2142.994,635.737s-3.776,5.153-3.583,9.318,1.79,6.5,3.074,5.834-1.869-4.167-.9-7.141S-2139.684,633-2142.994,635.737Z",
    transform: "translate(2203.452 -404.98)",
    fill: "#232323"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87713",
    "data-name": "Group 87713",
    transform: "translate(0 381.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87710",
    "data-name": "Group 87710",
    transform: "translate(41.762 9.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161485",
    "data-name": "Path 161485",
    d: "M-2219.394,485.915s-22.093,73.6-21.614,128.168h14.047s6.364-99.653,20.071-126.6Z",
    transform: "translate(2241.018 -485.915)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161486",
    "data-name": "Path 161486",
    d: "M-2241.009,614.082h2.479c3.868-21.522,11.607-48.55,18.768-71.217,3.183-22.723,7.453-44.729,12.869-55.38l-12.5-1.569S-2241.486,559.516-2241.009,614.082Z",
    transform: "translate(2241.017 -485.914)",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87711",
    "data-name": "Group 87711",
    transform: "translate(64.353 13.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161487",
    "data-name": "Path 161487",
    d: "M-2224.754,488.45s-10.848,84.391-.509,143.806l15.32-2.624s-10.991-109.872-.893-141.809Z",
    transform: "translate(2229.729 -487.824)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161488",
    "data-name": "Path 161488",
    d: "M-2225.262,632.257l2.7-.46c.346-24.192,3.933-55.116,7.655-81.171-.618-25.373.076-50.171,4.068-62.8l-13.918.624S-2235.6,572.84-2225.262,632.257Z",
    transform: "translate(2229.729 -487.824)",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87712",
    "data-name": "Group 87712",
    transform: "translate(0 1.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161489",
    "data-name": "Path 161489",
    d: "M-2197.055,482.287s-63.756,11.207-64.792,36.374,20.145,33.206,34.058,27.7,36.548-42.3,38.211-48.852Zm-26.115,40.5c-11.057,6.03-16.665,1.745-16.665,1.745s-1.713-1.111.778-6.028,41.793-26.7,41.793-26.7-14.844,24.958-25.9,30.982Z",
    transform: "translate(2261.884 -482.287)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161490",
    "data-name": "Path 161490",
    d: "M-2261.847,518.524c-.444,10.751,3.174,18.368,8.542,23.143l8.9.328,3.326-14.249.827-6.9.26-.284a16.19,16.19,0,0,1,.933-2.2,23.7,23.7,0,0,1,6.11-5.231,290.561,290.561,0,0,1,34.442-30.708C-2207.965,484.265-2260.9,495.607-2261.847,518.524Z",
    transform: "translate(2261.885 -482.15)",
    fill: "#e0e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161491",
    "data-name": "Path 161491",
    d: "M-2206.723,487.04s-46.933,20.307-45.686,29.187a35,35,0,0,0,6.852,15.65s-5.191-12.692-1.869-17.766S-2206.723,487.04-2206.723,487.04Z",
    transform: "translate(2271.348 -477.528)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161492",
    "data-name": "Path 161492",
    d: "M-2244.856,527.777s-6.646-9.1-6.646-12.692c0-2.5,13.809-18.752,22.178-28.385-15.766,5.864-31.577,14.762-32.519,27.018C-2260.36,528.489-2244.856,527.777-2244.856,527.777Z",
    transform: "translate(2261.926 -477.868)",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161493",
    "data-name": "Path 161493",
    d: "M-2087.332,595.112s2.087,7-8.217,7.659-1.043-17.041-1.043-17.041Z",
    transform: "translate(2423.564 -376.729)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161494",
    "data-name": "Path 161494",
    d: "M-2233.03,485.471s22.843,23.684,27.818,71.479-8.721,153.114-4.15,156.078,65.623,19.032,76.214,16.707,13.293-3.14,19.313.228,24.508,3.828,45.272,0,17.237,7.535,41.743,2.7,40.911-15.408,48.8-24.078,20.35-12.474,24.5-8.672c0,0,4.152-93.9-2.076-125.622s-7.893-57.524-6.23-68.094,6.645-16.925-5.815-20.726c0,0,.1,18.4-34.785,25.06s-135.817,10.151-177.868-8.566S-2238.273,475.951-2233.03,485.471Z",
    transform: "translate(2289.812 -481.298)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161495",
    "data-name": "Path 161495",
    d: "M-2180,630.465a15.161,15.161,0,0,1,12.1,1.753,10.478,10.478,0,0,0,1.126.532c8.005-26.617,24.416-53.835,24.416-53.835C-2154.887,589.1-2171.976,616.792-2180,630.465Z",
    transform: "translate(2343.879 -383.553)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161496",
    "data-name": "Path 161496",
    d: "M-2144.538,681.079c7.591,1.727,11.038,6.246,28.151,2.874.352-.074.684-.152,1.032-.226,8.155-32.95,21.394-71.891,28.663-92.162,17.868-49.833,15.8-61.622,15.8-61.622s-15.574,46.316-33.955,72.648C-2114.284,616.106-2133.761,652.45-2144.538,681.079Z",
    transform: "translate(2379.384 -432.59)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161497",
    "data-name": "Path 161497",
    d: "M-2105.435,568.724c-16.247,21.494-33.488,53.381-41.79,72.9a26.851,26.851,0,0,1,9.45,1.865A453.962,453.962,0,0,1-2105.435,568.724Z",
    transform: "translate(2376.695 -393.757)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161498",
    "data-name": "Path 161498",
    d: "M-2094.364,548.372l-12.646,94.95c.656-.638,1.28-1.279,1.849-1.9a33.734,33.734,0,0,1,12.934-8.744Z",
    transform: "translate(2416.962 -414.136)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161499",
    "data-name": "Path 161499",
    d: "M-2215.978,535c-.583,51.8-8.946,121.85-5.229,124.257a73.843,73.843,0,0,0,11.551,3.955C-2208.261,636.246-2206.47,574.9-2215.978,535Z",
    transform: "translate(2301.665 -427.525)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161500",
    "data-name": "Path 161500",
    d: "M-2137.861,509.977s-32.292,9.726-54.1,5.606c0,0,3.426,33.944,17.755,42.828s47.349,10.071,47.349,10.071-46.725,13.407-65.1-8.806c0,0-2.146,36.16,14.347,62.809a209.962,209.962,0,0,1-29.275-78.67c-7.189-46.318-18.866-52.352-18.866-52.352S-2186.145,512.615-2137.861,509.977Z",
    transform: "translate(2298.063 -471.119)",
    fill: "#e0e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161501",
    "data-name": "Path 161501",
    d: "M-2227.286,485.707s29.073,27.916,90.959,30.034C-2136.326,515.741-2227.286,525.889-2227.286,485.707Z",
    transform: "translate(2296.528 -476.883)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161502",
    "data-name": "Path 161502",
    d: "M-2220.858,485.575s-11.526-5.922-10.383-1.161,13.916,24.072,17.237,35.623c0,0-4.541-16.635-10.7-27.476C-2227.649,487.351-2228.826,484.749-2220.858,485.575Z",
    transform: "translate(2292.488 -480.031)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161503",
    "data-name": "Path 161503",
    d: "M-2222.668,492.926l36.238,62.583s31.981,16.073,56.485,11.5c0,0-40.078-2.035-52.955-17.049S-2222.668,492.926-2222.668,492.926Z",
    transform: "translate(2301.152 -469.654)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161504",
    "data-name": "Path 161504",
    d: "M-2184.488,603.224a143.119,143.119,0,0,1-33.092-92.523S-2208.393,568.645-2184.488,603.224Z",
    transform: "translate(2306.244 -451.856)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161505",
    "data-name": "Path 161505",
    d: "M-2226.451,484.035s30.82,28.991,93.285,31.685c0,0-47.031-6.662-68.219-18.4S-2226.451,484.035-2226.451,484.035Z",
    transform: "translate(2297.364 -478.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161506",
    "data-name": "Path 161506",
    d: "M-2149.45,513.637s58.55,3.8,80.146-7.2c13.711-6.985,18.492-16.975,17.892-22.775-.28-.094-.562-.188-.862-.276,0,0,.1,18.4-34.785,25.06-13.409,2.558-36.572,4.651-62.4,5.187Z",
    transform: "translate(2374.458 -479.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161507",
    "data-name": "Path 161507",
    d: "M-2082.765,495.113s-20.56,35.527-38,51.7Z",
    transform: "translate(2403.184 -467.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161508",
    "data-name": "Path 161508",
    d: "M-2090.708,527.29s-25.232,40.284-39.56,51.39-16.811,24.426-16.811,24.426-4.061-12.052,18.056-33.622A483.873,483.873,0,0,0-2090.708,527.29Z",
    transform: "translate(2376.548 -435.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161509",
    "data-name": "Path 161509",
    d: "M-2088.949,497.65l-24.09,54.986A118.3,118.3,0,0,0-2088.949,497.65Z",
    transform: "translate(2410.925 -464.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161510",
    "data-name": "Path 161510",
    d: "M-2102.235,588.748l3.074-77.109A212.472,212.472,0,0,0-2102.235,588.748Z",
    transform: "translate(2419.579 -450.917)",
    fill: "#fff"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161511",
    "data-name": "Path 161511",
    d: "M-2192.715,383.093s2.546-15.7,10.333-18.082l2.648-19.351-18.966,13.165v19.831Z",
    transform: "translate(2325.151 -235.358)",
    fill: "#3c2517"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161512",
    "data-name": "Path 161512",
    d: "M-2158.983,390.761a24.031,24.031,0,0,0,23.777-4.231s1.247-1.427,1.974,0,2.023,14.433-5.556,18.452-16.665.16-20.87-4.917S-2163.032,389.174-2158.983,390.761Z",
    transform: "translate(2361.458 -195.069)",
    fill: "#3c2517"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87715",
    "data-name": "Group 87715",
    transform: "translate(73.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161513",
    "data-name": "Path 161513",
    d: "M-2167.025,318.035c-1.643-3.484-3.677-7.035-6.98-8.874-3.179-1.769-7.009-1.657-10.593-1.179a61.774,61.774,0,0,0-13.141,3.246,29.716,29.716,0,0,0-8.427,4.443,15.236,15.236,0,0,0-5.392,7.879c-1.286,4.957.609,10.211,3.114,14.638a19.315,19.315,0,0,0,4.529,5.744,32,32,0,0,0,3.54,2.247c4.2,2.524,4.375,29.744,9.43,35.994.248.308,16.531-7.775,18.168-8.466q9.243-3.882,18.74-7.055c3.867-1.295,11.939-1.955,13.084-6.885.575-2.47-.616-5.183-1.341-7.471-1.024-3.266-18.816-18.924-19.489-20.922A122.685,122.685,0,0,0-2167.025,318.035Z",
    transform: "translate(2238.299 -273.389)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161514",
    "data-name": "Path 161514",
    d: "M-2135.326,356.053a4.04,4.04,0,0,0,3.863-3.941,10.106,10.106,0,0,0-2.684-6.88,19.119,19.119,0,0,0-5.4-2.764c2.283-3.03,1.189-6.436-1.865-8.65a17.2,17.2,0,0,0-10.8-2.374c-16.719.57-32.773,7.9-45.882,18.49a17.706,17.706,0,0,0-5.655,6.578,6.942,6.942,0,0,0,1.553,8.047,7,7,0,0,0,.82,8.836,10.134,10.134,0,0,0,8.946,2.382,20.628,20.628,0,0,0,8.568-4.2c2.573-1.943,4.929-4.169,7.555-6.038a46.763,46.763,0,0,1,18.824-7.457A101.082,101.082,0,0,1-2135.326,356.053Z",
    transform: "translate(2245.868 -249.697)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161515",
    "data-name": "Path 161515",
    d: "M-2196.389,316.208a23.063,23.063,0,0,0,21.746,24.212,22.92,22.92,0,0,0,23.4-22.455l0-.038a23.062,23.062,0,0,0-21.746-24.21,22.913,22.913,0,0,0-23.4,22.447Z",
    transform: "translate(2253.88 -287.379)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161516",
    "data-name": "Path 161516",
    d: "M-2195.686,314.8a21.619,21.619,0,0,0,20.384,22.7,21.488,21.488,0,0,0,21.942-21.048v-.04a21.614,21.614,0,0,0-20.381-22.7,21.489,21.489,0,0,0-21.945,21.046Z",
    transform: "translate(2254.587 -287.382)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161517",
    "data-name": "Path 161517",
    d: "M-2225.1,329.718a23.064,23.064,0,0,0,21.747,24.212,22.923,22.923,0,0,0,23.4-22.461v-.034a23.062,23.062,0,0,0-21.747-24.208,22.916,22.916,0,0,0-23.4,22.449Z",
    transform: "translate(2225.128 -273.851)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161518",
    "data-name": "Path 161518",
    d: "M-2224.533,328.538a20.55,20.55,0,0,0,19.376,21.576,20.427,20.427,0,0,0,20.854-20.019v-.024a20.547,20.547,0,0,0-19.375-21.574,20.42,20.42,0,0,0-20.854,20Z",
    transform: "translate(2225.702 -272.579)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161519",
    "data-name": "Path 161519",
    d: "M-2216.3,314.688a24.739,24.739,0,0,0,23.325,25.975,24.586,24.586,0,0,0,25.107-24.086l0-.046a24.737,24.737,0,0,0-23.325-25.975,24.588,24.588,0,0,0-25.108,24.086Z",
    transform: "translate(2233.937 -290.544)",
    fill: "#b0b0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161520",
    "data-name": "Path 161520",
    d: "M-2215.683,313.446a23.469,23.469,0,0,0,22.126,24.642,23.328,23.328,0,0,0,23.819-22.853l0-.04a23.47,23.47,0,0,0-22.13-24.64,23.321,23.321,0,0,0-23.816,22.845Z",
    transform: "translate(2234.56 -290.545)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161521",
    "data-name": "Path 161521",
    d: "M-2149.76,337.172A78.143,78.143,0,0,0-2192,348.449a27.738,27.738,0,0,0-8,6.646,12.552,12.552,0,0,0-2.634,9.882c1.957-7.393,7.825-13.209,14.487-16.755s14.122-5.181,21.476-6.762a80.635,80.635,0,0,1,16.517-2.375,38.181,38.181,0,0,1,14.954,3.68C-2138.078,338.137-2144.881,337.3-2149.76,337.172Z",
    transform: "translate(2247.499 -243.877)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161522",
    "data-name": "Path 161522",
    d: "M-2195.9,347.421c-3.88,3.2-7.649,7.449-7.509,12.524a47.332,47.332,0,0,1,23.119-16.753,102.034,102.034,0,0,1,28.316-5.025c1.533-.1,6.058-.332,6.2-2.54.17-2.56-3.781-2.564-5.33-2.66a63.842,63.842,0,0,0-16.211,1.071A64.628,64.628,0,0,0-2195.9,347.421Z",
    transform: "translate(2246.872 -248.188)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161523",
    "data-name": "Path 161523",
    d: "M-2208.964,313.683c-9.937-3.166-4.243-15.11,1.943-18.87,8.8-5.347,21.9-5.129,28.925,3.462a10.741,10.741,0,0,1,2.808,7.413,10.536,10.536,0,0,1-2.794,5.862c-2.178,2.538-5.18,4.543-8.341,4.253-3.331-.308-6-3.006-8.688-5.183s-6.284-3.985-9.276-2.338a2.306,2.306,0,0,0-1.337,1.909,1.968,1.968,0,0,0,1.421,1.729,7.48,7.48,0,0,0,2.253.152,10.04,10.04,0,0,1,7.229,3.28,12.729,12.729,0,0,0-7-1.235A20.9,20.9,0,0,1-2208.964,313.683Z",
    transform: "translate(2235.913 -289.865)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161524",
    "data-name": "Path 161524",
    d: "M-2164.945,303.858a22.885,22.885,0,0,0-13.8-8.756,11.11,11.11,0,0,0-5.223-.162,6.249,6.249,0,0,0-4.177,3.544,8.648,8.648,0,0,0,2.006,8.928,12.7,12.7,0,0,0,7.673,3.216c2.734.348,5.521.382,8.147,1.367a9.425,9.425,0,0,1,5.954,6.344,10.774,10.774,0,0,0-8.481-4.267c.8,0,2.646,2.053,3.354,2.608,1.115.865,2.209,1.819,3.362,2.61,1.6,1.1,3.382,1.349,4.535-.741C-2159.315,314.407-2162.683,306.994-2164.945,303.858Z",
    transform: "translate(2261.669 -286.381)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161525",
    "data-name": "Path 161525",
    d: "M-2201.727,317.016a7.191,7.191,0,0,0-4.021,5.738,24.113,24.113,0,0,0,.409,7.379,18.554,18.554,0,0,1,.054,7.369c-1.153,4.443-6.074,7.615-10.309,6.224a11.267,11.267,0,0,1-6.114-6.068,21.728,21.728,0,0,1-.8-16.963c1.617-4.275,5.271-9.336,9.656-10.871,2.233-.776,3.672.168,5.131,1.893A20.426,20.426,0,0,0-2201.727,317.016Z",
    transform: "translate(2226.4 -271.517)",
    fill: "#f8e8d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87714",
    "data-name": "Group 87714",
    transform: "translate(43.397 48.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161526",
    "data-name": "Path 161526",
    d: "M-2199.589,321.081c1.915,2.374,4.743,20.8,7.907,24.652.06.07.118.144.174.212a45.458,45.458,0,0,0-7.385,6.226c-1.965-2.78-1.707-23.423-2.9-25.141A22.2,22.2,0,0,0-2199.589,321.081Z",
    transform: "translate(2205.095 -308.411)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161527",
    "data-name": "Path 161527",
    d: "M-2181.252,345.468c-3.59-7.071-12.641-23.718-14.822-28.082-.185-.37-.365-.74-.564-1.1a21.9,21.9,0,0,0,3.6-1.537c3.25,4.647,15.72,20.956,18.96,29.611A44.36,44.36,0,0,0-2181.252,345.468Z",
    transform: "translate(2210.258 -314.75)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161528",
    "data-name": "Path 161528",
    d: "M-2196.823,315.981c2.856,4.655,9.806,22.137,13.533,30.212a47.3,47.3,0,0,0-6.6,3.2c-3.8-5.932-7.875-24.288-10.19-27.944a20.9,20.9,0,0,0-.7-5.419A21.117,21.117,0,0,0-2196.823,315.981Z",
    transform: "translate(2206.107 -313.517)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161529",
    "data-name": "Path 161529",
    d: "M-2191.517,316.995a13.966,13.966,0,0,0,3.416.919c1.361,3.338,17.009,19.415,19.249,24.832a37.069,37.069,0,0,0-4.745-.634C-2174.78,335.9-2189.2,320.1-2191.517,316.995Z",
    transform: "translate(2215.385 -312.502)",
    fill: "#cfd4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161530",
    "data-name": "Path 161530",
    d: "M-2200.4,351.536c-.176.234-.353.458-.524.694-2.082-2.412-.727-24.338-2.518-25.084a19.006,19.006,0,0,0,1.487-1.715C-2200.8,326.992-2202.31,349-2200.4,351.536Z",
    transform: "translate(2203.443 -304.055)",
    fill: "#cfd4d7"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161531",
    "data-name": "Path 161531",
    d: "M-2185.433,368.737s-5.14-13.325-12.3-8.724-9.347,20.938,7.321,29.019Z",
    transform: "translate(2320.726 -221.953)",
    fill: "#e49f71"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161532",
    "data-name": "Path 161532",
    d: "M-2158.518,398.658-2137.7,420.2l-40.794-11.968Z",
    transform: "translate(2345.379 -182.29)",
    fill: "#f0ecf5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161533",
    "data-name": "Path 161533",
    d: "M-2171.425,380.232s24.7,5.073,42.994-1.271c0,0,.382,12.943-11.7,13.851C-2146.777,393.316-2163.306,387.21-2171.425,380.232Z",
    transform: "translate(2352.462 -202.013)",
    fill: "#ae2824"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161534",
    "data-name": "Path 161534",
    d: "M-2155.849,388.49q12.321.234,24.637-.336a16.631,16.631,0,0,0,2.779-9.192c-18.3,6.344-42.992,1.271-42.992,1.271a56.269,56.269,0,0,0,14.063,8.221C-2156.858,388.464-2156.353,388.48-2155.849,388.49Z",
    transform: "translate(2352.462 -202.012)",
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87716",
    "data-name": "Group 87716",
    transform: "translate(151.102 155.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161535",
    "data-name": "Path 161535",
    d: "M-2097.165,383.876c2.65-2.1,2.352-8.692,2.352-8.692l-1.765,1.2c1.176-3.6-3.532-8.1-3.532-8.1a11.9,11.9,0,0,1-.887,6.9l-2.06-1.8c-.588,5.1-4.12,2.7-4.12,2.7a58.338,58.338,0,0,0-13.837-5.4c-4.693-1.8-7.695,1.707-9.186,4.259a10.032,10.032,0,0,0-5.241-1.859s-3.823-1.2-11.186,3c0,0-17.075,8.692-23.549,7.195,0,0-9.422.9-5.6-5.1a7.785,7.785,0,0,0-7.949,4.2s-1.475,3.6.586,5.692a4.889,4.889,0,0,1-3.237-1.8s-.294,7.2,4.711,8.7a4.369,4.369,0,0,1-3.536,0,14.008,14.008,0,0,0,10.307,8.7s2.062,3.9,9.422,3.6c0,0,10.007,2.1,19.429-8.99,0,0,6.776-7.5,11.777-10.207a13.553,13.553,0,0,0,5.438-5.291,9.531,9.531,0,0,0,3.4,2.3c3.535.9,10.3,3.6,10.3,3.6,7.067,6.592,12.953,4.8,12.953,4.8,7.363-1.2,8.54-10.191,8.54-10.191C-2094.515,384.775-2097.165,383.876-2097.165,383.876Z",
    transform: "translate(2186.383 -368.29)",
    fill: "#3c2517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161536",
    "data-name": "Path 161536",
    d: "M-2097.174,383.675c2.65-2.1,2.352-8.694,2.352-8.694l-1.765,1.2c.966-2.952-2.025-6.5-3.134-7.689,3.068,6.756-.4,9.786-.4,9.786a14.818,14.818,0,0,1-1.179,4.5,7.153,7.153,0,0,0,2.649-1.5,51.386,51.386,0,0,1-1.471,5.4c-2.65,6.9-11.776.6-11.776.6-5-5.1-15.908-8.678-15.908-8.678a14,14,0,0,1-2.934,2.085c-5,2.7-11.774,10.193-11.774,10.193-9.424,11.1-19.431,9-19.431,9-7.363.3-9.418-3.6-9.418-3.6a14.014,14.014,0,0,1-10.3-8.7,4.359,4.359,0,0,0,3.532,0c-3.392-1.017-4.347-4.643-4.6-6.885a8.809,8.809,0,0,0-.983,1.491s-1.475,3.6.587,5.692a4.884,4.884,0,0,1-3.237-1.8s-.294,7.2,4.711,8.7a4.369,4.369,0,0,1-3.536,0,14.008,14.008,0,0,0,10.307,8.7s2.06,3.9,9.42,3.6c0,0,10.006,2.1,19.431-8.99,0,0,6.774-7.5,11.775-10.207a14.16,14.16,0,0,0,3.479-2.628h0c.05-.054.1-.112.156-.162l.229-.254c.132-.146.26-.3.386-.458.048-.06.1-.118.146-.182.172-.22.336-.446.5-.688a.016.016,0,0,1,.014-.016,10.391,10.391,0,0,0,.533-.9,9.516,9.516,0,0,0,3.4,2.3c3.536.9,10.307,3.6,10.307,3.6,7.067,6.592,12.952,4.793,12.952,4.793,7.363-1.2,8.54-10.191,8.54-10.191C-2094.524,384.572-2097.174,383.675-2097.174,383.675Z",
    transform: "translate(2186.392 -368.087)",
    fill: "#21140d"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161537",
    "data-name": "Path 161537",
    d: "M-2167.551,348.752s-2.648,18.082,10.747,15.86,18.222-9.516,30.528-5.552,4.051,30.928-7.165,37.116-26,7.615-26.785-4.6,13.078-4.6,14.323-3.488l1.941-1.033s-3.5-6.108-3.8-6.424-10.278-4.285-10.9-4.841-10.747-3.568-11.682-5.313-1.01-14.832-1.01-14.832Z",
    transform: "translate(2352.528 -232.262)",
    fill: "#f0ab7e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161538",
    "data-name": "Path 161538",
    d: "M-2128.044,358.874c-12.3-3.965-17.133,3.332-30.526,5.552-12.264,2.033-11.079-12.944-10.795-15.488h0s-2.133,14.644,6.745,16.229,17.365-5.77,23.985-6.5,14.122,1.111,15.782,7.351-2.231,22.152-11.784,28.973c0,0-12.316,7.6-22.174,3.965a9.477,9.477,0,0,1-4.641-8.988s-.662-9.832,13.783-2.059c-1.245-1.111-15.108-8.726-14.323,3.488s15.57,10.787,26.786,4.6S-2115.746,362.84-2128.044,358.874Z",
    transform: "translate(2354.301 -232.077)",
    fill: "#e49f71"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161539",
    "data-name": "Path 161539",
    d: "M-2161.5,414.085l16.031-13.923,5.429,10.207Z",
    transform: "translate(2362.4 -180.785)",
    fill: "#f0ecf5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87725",
    "data-name": "Group 87725",
    transform: "translate(186.146 276.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87718",
    "data-name": "Group 87718",
    transform: "translate(12.264 66.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161540",
    "data-name": "Path 161540",
    d: "M-2144.234,471.7a9.339,9.339,0,0,1-9.256,9.422,9.341,9.341,0,0,1-9.253-9.422,9.342,9.342,0,0,1,9.253-9.424A9.339,9.339,0,0,1-2144.234,471.7Z",
    transform: "translate(2162.744 -462.276)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161541",
    "data-name": "Path 161541",
    d: "M-2145.246,471.353a8.658,8.658,0,0,1-8.58,8.738h0a8.66,8.66,0,0,1-8.579-8.738,8.66,8.66,0,0,1,8.579-8.736A8.66,8.66,0,0,1-2145.246,471.353Z",
    transform: "translate(2163.081 -461.935)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87717",
    "data-name": "Group 87717",
    transform: "translate(5.798 6.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161542",
    "data-name": "Path 161542",
    d: "M-2157.846,466.372a1.009,1.009,0,0,1-1,1.021h0a1.013,1.013,0,0,1-1-1.021,1,1,0,0,1,.982-1.017l.018,0a1,1,0,0,1,1,1Z",
    transform: "translate(2159.847 -465.353)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161543",
    "data-name": "Path 161543",
    d: "M-2155.389,466.372a1.01,1.01,0,0,1-1,1.021h0a1.013,1.013,0,0,1-1-1.021,1,1,0,0,1,.983-1.017l.018,0a1,1,0,0,1,1,1Z",
    transform: "translate(2162.308 -465.353)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161544",
    "data-name": "Path 161544",
    d: "M-2157.846,468.619a1.011,1.011,0,0,1-1,1.023,1.013,1.013,0,0,1-1-1.023,1.011,1.011,0,0,1,1-1.021h0a1,1,0,0,1,1,1Z",
    transform: "translate(2159.847 -463.105)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161545",
    "data-name": "Path 161545",
    d: "M-2155.389,468.619a1.011,1.011,0,0,1-1,1.023,1.015,1.015,0,0,1-1-1.023,1.013,1.013,0,0,1,1-1.021h0a1,1,0,0,1,1,1Z",
    transform: "translate(2162.307 -463.105)",
    fill: "#8f919b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87720",
    "data-name": "Group 87720",
    transform: "translate(81.656 52.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161546",
    "data-name": "Path 161546",
    d: "M-2112.207,463.076a8,8,0,0,1-7.929,8.079h0a8,8,0,0,1-7.932-8.077v0a8.008,8.008,0,0,1,7.932-8.077,8.005,8.005,0,0,1,7.933,8.077Z",
    transform: "translate(2128.071 -454.999)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161547",
    "data-name": "Path 161547",
    d: "M-2113.075,462.781a7.419,7.419,0,0,1-7.351,7.489h0a7.421,7.421,0,0,1-7.355-7.489,7.423,7.423,0,0,1,7.355-7.487h0a7.421,7.421,0,0,1,7.353,7.485Z",
    transform: "translate(2128.36 -454.704)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87719",
    "data-name": "Group 87719",
    transform: "translate(4.966 5.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161548",
    "data-name": "Path 161548",
    d: "M-2123.873,458.51a.865.865,0,0,1-.856.877h0a.865.865,0,0,1-.859-.872v0a.87.87,0,0,1,.859-.875A.871.871,0,0,1-2123.873,458.51Z",
    transform: "translate(2125.59 -457.637)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161549",
    "data-name": "Path 161549",
    d: "M-2121.768,458.51a.863.863,0,0,1-.853.877h-.006a.866.866,0,0,1-.859-.872v0a.87.87,0,0,1,.859-.875A.869.869,0,0,1-2121.768,458.51Z",
    transform: "translate(2127.698 -457.637)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161550",
    "data-name": "Path 161550",
    d: "M-2123.873,460.436a.863.863,0,0,1-.858.875h0a.865.865,0,0,1-.859-.873v0a.868.868,0,0,1,.859-.875h0a.867.867,0,0,1,.858.875Z",
    transform: "translate(2125.59 -455.711)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161551",
    "data-name": "Path 161551",
    d: "M-2121.768,460.436a.863.863,0,0,1-.855.875h0a.866.866,0,0,1-.859-.873v0a.869.869,0,0,1,.859-.875h0a.865.865,0,0,1,.859.871Z",
    transform: "translate(2127.698 -455.711)",
    fill: "#8f919b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87722",
    "data-name": "Group 87722",
    transform: "translate(63.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161552",
    "data-name": "Path 161552",
    d: "M-2121.083,436.972a8,8,0,0,1-7.931,8.077,8,8,0,0,1-7.932-8.077,8.007,8.007,0,0,1,7.932-8.077A8.006,8.006,0,0,1-2121.083,436.972Z",
    transform: "translate(2136.945 -428.895)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161553",
    "data-name": "Path 161553",
    d: "M-2121.948,436.679a7.422,7.422,0,0,1-7.355,7.491,7.424,7.424,0,0,1-7.353-7.491,7.426,7.426,0,0,1,7.353-7.489A7.423,7.423,0,0,1-2121.948,436.679Z",
    transform: "translate(2137.235 -428.6)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87721",
    "data-name": "Group 87721",
    transform: "translate(4.968 5.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161554",
    "data-name": "Path 161554",
    d: "M-2132.746,432.408a.864.864,0,0,1-.858.875h0a.864.864,0,0,1-.858-.871v0a.868.868,0,0,1,.858-.875h0A.869.869,0,0,1-2132.746,432.408Z",
    transform: "translate(2134.463 -431.533)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161555",
    "data-name": "Path 161555",
    d: "M-2130.641,432.408a.866.866,0,0,1-.858.875h0a.865.865,0,0,1-.857-.871v0a.869.869,0,0,1,.857-.875A.87.87,0,0,1-2130.641,432.408Z",
    transform: "translate(2136.573 -431.533)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161556",
    "data-name": "Path 161556",
    d: "M-2132.746,434.333a.867.867,0,0,1-.858.875.865.865,0,0,1-.858-.875h0a.868.868,0,0,1,.858-.875h0A.869.869,0,0,1-2132.746,434.333Z",
    transform: "translate(2134.463 -429.605)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161557",
    "data-name": "Path 161557",
    d: "M-2130.641,434.333a.866.866,0,0,1-.858.875h0a.867.867,0,0,1-.857-.875.869.869,0,0,1,.857-.875A.87.87,0,0,1-2130.641,434.333Z",
    transform: "translate(2136.573 -429.605)",
    fill: "#8f919b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87724",
    "data-name": "Group 87724",
    transform: "translate(0 15.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161558",
    "data-name": "Path 161558",
    d: "M-2150.362,445.831a9.339,9.339,0,0,1-9.256,9.424,9.339,9.339,0,0,1-9.254-9.424,9.345,9.345,0,0,1,9.254-9.426A9.342,9.342,0,0,1-2150.362,445.831Z",
    transform: "translate(2168.873 -436.405)",
    fill: "#abafb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161559",
    "data-name": "Path 161559",
    d: "M-2151.374,445.488a8.661,8.661,0,0,1-8.582,8.74,8.662,8.662,0,0,1-8.58-8.74,8.664,8.664,0,0,1,8.58-8.74A8.665,8.665,0,0,1-2151.374,445.488Z",
    transform: "translate(2169.21 -436.062)",
    fill: "#cbd9e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87723",
    "data-name": "Group 87723",
    transform: "translate(5.794 6.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161560",
    "data-name": "Path 161560",
    d: "M-2163.976,440.509a1.012,1.012,0,0,1-1,1.021,1.016,1.016,0,0,1-1-1.021,1.014,1.014,0,0,1,1-1.023A1.014,1.014,0,0,1-2163.976,440.509Z",
    transform: "translate(2165.977 -439.486)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161561",
    "data-name": "Path 161561",
    d: "M-2161.518,440.509a1.012,1.012,0,0,1-1,1.021,1.013,1.013,0,0,1-1-1.021,1,1,0,0,1,.979-1.021l.022,0A1.014,1.014,0,0,1-2161.518,440.509Z",
    transform: "translate(2168.438 -439.486)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161562",
    "data-name": "Path 161562",
    d: "M-2163.976,442.749a1.012,1.012,0,0,1-1,1.021,1.015,1.015,0,0,1-1-1.021,1.016,1.016,0,0,1,1-1.021A1.014,1.014,0,0,1-2163.976,442.749Z",
    transform: "translate(2165.977 -437.241)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161563",
    "data-name": "Path 161563",
    d: "M-2161.518,442.749a1.012,1.012,0,0,1-1,1.021,1.008,1.008,0,0,1-1-1.019v0a1,1,0,0,1,.98-1.019l.02,0a1.012,1.012,0,0,1,1,1.021Z",
    transform: "translate(2168.438 -437.241)",
    fill: "#8f919b"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87726",
    "data-name": "Group 87726",
    transform: "translate(159.987 109.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161564",
    "data-name": "Path 161564",
    d: "M-2180.488,351.274l-1.455,7.507,13.187-9.358.572-3.915Z",
    transform: "translate(2181.943 -345.384)",
    fill: "#3c2517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161565",
    "data-name": "Path 161565",
    d: "M-2169.8,345.458v3.648s11.319-.582,13.913,1.375a4.7,4.7,0,0,0-2.8-4.175A58.074,58.074,0,0,0-2169.8,345.458Z",
    transform: "translate(2194.099 -345.446)",
    fill: "#3c2517"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161566",
    "data-name": "Path 161566",
    d: "M-2164.444,354.456s-1.137,5.219-3.776,5.926-11.972-.917-11.972-.917,9.5,3.732,13.3,2.227S-2164.444,354.456-2164.444,354.456Z",
    transform: "translate(2343.684 -226.55)",
    fill: "#1b100e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161567",
    "data-name": "Path 161567",
    d: "M-2168.219,352.288s.833,3.82,2.762,4.335a37.964,37.964,0,0,0,8.763-.666s-6.952,2.73-9.736,1.629S-2168.219,352.288-2168.219,352.288Z",
    transform: "translate(2355.499 -228.721)",
    fill: "#1b100e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161568",
    "data-name": "Path 161568",
    d: "M-2179.625,363.265s.572-9.3,5.555-10.945a9.157,9.157,0,0,1,8.828,2.313S-2177.29,345.235-2179.625,363.265Z",
    transform: "translate(2344.251 -229.011)",
    fill: "#e49f71"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161569",
    "data-name": "Path 161569",
    d: "M-2201.317,362.464s10.245,2.372,8.939,5.025-5.868,7.2-.93,8.061,1.489,2.844-1.956,0,1.77-8.061,1.77-8.061S-2197.22,363.126-2201.317,362.464Z",
    transform: "translate(2322.531 -218.532)",
    fill: "#e49f71"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87730",
    "data-name": "Group 87730",
    transform: "translate(162.949 213.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161570",
    "data-name": "Path 161570",
    d: "M-2118.509,406.877c.723-.877,1.647,2.4,1.6,3.846s-9.492,8.918-10.193,9.832c-6.32,8.229-14.921,10.449-23.089,10.837-9.522.464-19.459-1.351-27.526-9.354a8.2,8.2,0,0,1-2.746-5.343c-.138-2.368,4.649-3.783,5.686-2.059-1.583-2.522-1.885-8.606-1.339-12.05.895-5.668,2.548-6.082,4.471-4.253,8.566,8.129,21.087,20.361,29.525,20.554,3.958.092,6.932-5.474,10.761-7.267,1.013-.472,7.061-8.994,8.142-8.652C-2121.635,403.463-2116.99,405.432-2118.509,406.877Z",
    transform: "translate(2180.464 -397.363)",
    fill: "#ae2824"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87729",
    "data-name": "Group 87729",
    transform: "translate(43.363 20.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87728",
    "data-name": "Group 87728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87727",
    "data-name": "Group 87727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161571",
    "data-name": "Path 161571",
    d: "M-2157.011,413.8a8.788,8.788,0,0,1,6.072-5.942,6.938,6.938,0,0,1,6.693,4c1.823,3.08,2.644,7.5,4.708,10.2a4.725,4.725,0,0,0,6.5,1.559,4.121,4.121,0,0,0,.449-.312,6.035,6.035,0,0,0,2.2-4.109,4.837,4.837,0,0,0-.913-3.438,8.313,8.313,0,0,1,2.976,5.848,17.042,17.042,0,0,1-1.529,8.868,18.05,18.05,0,0,1-4.579,5.93c-4.2,3.66-9.19,5.392-13.853,3.69s-8.884-7.163-10.225-14.447A20.777,20.777,0,0,1-2157.011,413.8Z",
    transform: "translate(2158.796 -407.847)",
    fill: "#ae2824"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_161572",
    "data-name": "Path 161572",
    d: "M-2144.729,414.958a58.713,58.713,0,0,0,2.1,5.946,4.847,4.847,0,0,0,5.93,2.82,10.525,10.525,0,0,0,5.18-5.874,17.074,17.074,0,0,1-2.189,12.5c-2.724,4.553-6.665,7.215-10.619,7.183s-7.887-2.77-10.579-7.369a2.929,2.929,0,0,0,3,.274,6.393,6.393,0,0,1-1.987-5.053,8.058,8.058,0,0,0-.07-2.137c-.464-1.773-2.483-1.681-2.666-3.57,1.447.62,3.084-1.067,3.479-3.316.387-2.179-.966-4.949.387-6.654C-2150.38,406.679-2145.935,411.858-2144.729,414.958Z",
    transform: "translate(2204.326 -385.92)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161573",
    "data-name": "Path 161573",
    d: "M-2150.562,416.577c4.277,4.321,5.446,15.244,4.245,23.035s-5.774,13.969-10.807,14.658-10.2-4.173-12.229-11.52a3.8,3.8,0,0,0,5.162,1.515,3.8,3.8,0,0,0,1.785-2.139c1.367-3.018.564-7.271-.626-10.471a30.76,30.76,0,0,1-2.854-10.047c-.124-5.043,2.854-9.418,6.022-9.858S-2153.24,413.871-2150.562,416.577Z",
    transform: "translate(2191.59 -383.008)",
    fill: "#ae2824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161574",
    "data-name": "Path 161574",
    d: "M-2155.549,412.836c-2.069-1.063-6.1-1.663-7.787,1.037a17.128,17.128,0,0,0-1.277,12.93,65.049,65.049,0,0,1,2.872,7.489,12.736,12.736,0,0,1-1.313,8.54,5.686,5.686,0,0,1-5.275,3.146c3.084,4.433,7.639,6.516,11.58,4.421s6.891-8.784,6.224-15.294a11.315,11.315,0,0,1-1.741,6.146c1.8-4.373-1.8-10.831.064-15.152a20.057,20.057,0,0,1,1.521-2.448C-2148.17,419.332-2153.333,413.983-2155.549,412.836Z",
    transform: "translate(2192.614 -382.769)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161575",
    "data-name": "Path 161575",
    d: "M-2161.193,420.2a8.161,8.161,0,0,1,3.866-6.274,4,4,0,0,0-5.575.971,3.8,3.8,0,0,0-.247.394,12.386,12.386,0,0,0-1.523,9.006c.652,3.112,2.381,5.406,3.124,8.47a14.173,14.173,0,0,1-.73,8.73,5.524,5.524,0,0,1-5.025,3.768c2.518,1.709,5.735.232,7.289-3.34a8.257,8.257,0,0,1-4.269,5.6,9.247,9.247,0,0,0,5.141-2,10.717,10.717,0,0,0,3.478-6.108,24.957,24.957,0,0,0-.03-7.909,41.8,41.8,0,0,1-.516-7.921c.158-2.1,2.68-6.706.58-7.777C-2157.037,415.1-2160.8,417.843-2161.193,420.2Z",
    transform: "translate(2193.641 -381.512)",
    fill: "#ee4823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161576",
    "data-name": "Path 161576",
    d: "M-2148.856,414.01c1.026,2.313,1.549,5.127,2.678,7.311,1.4,2.728,3.745,4.177,5.95,3.7a8.1,8.1,0,0,0,5.081-6.156,11.551,11.551,0,0,1-3.991,8.365,6.773,6.773,0,0,0,3.694-3.19,13.4,13.4,0,0,1-7.091,7.063,7.223,7.223,0,0,1-8.037-3.014,17.26,17.26,0,0,1-2.744-12.122c.244-1.715-.04-4.867,1.155-5.185S-2149.474,412.617-2148.856,414.01Z",
    transform: "translate(2207.465 -383.963)",
    fill: "#ee4823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161577",
    "data-name": "Path 161577",
    d: "M-2173.921,401.9c-.314-.426-.75-.887-1.1-.524a2.009,2.009,0,0,0-.29,1.255,19.371,19.371,0,0,0,3.5,11.7,19.711,19.711,0,0,1-3.718-6.684,24.405,24.405,0,0,0,1.5,7.377,9.337,9.337,0,0,0-2.556-2.58,2.092,2.092,0,0,0-2.872.668c6.07,7.263,13.609,11.407,21.214,11.652a35.857,35.857,0,0,1-9.69-8.958,42.8,42.8,0,0,0,9.1,6.48,3.844,3.844,0,0,0,3.094.6,3.123,3.123,0,0,0,1.695-3.184c-.2-1.553-1.4-1.833-2.189-2.225a42.018,42.018,0,0,1-6.37-3.909A53.727,53.727,0,0,1-2173.921,401.9Z",
    transform: "translate(2181.472 -393.478)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161578",
    "data-name": "Path 161578",
    d: "M-2149.01,410.948a7.046,7.046,0,0,0-4.17-4.7c-1.744-.376-3.685,1.135-4.253,3.782a5.521,5.521,0,0,0-4.257-1.645,4.37,4.37,0,0,0-2.386,4.925,5.161,5.161,0,0,0,2.9,3.458c1.459.891,2.732,2.1,4.2,2.9.778.428,3.827,2.277,3.951,3.8a6.71,6.71,0,0,1,1.233-4.637,2,2,0,0,1,2.757-.636,1.951,1.951,0,0,1,.426.356c.759.688,1.337,1.773,1.141-.8A24.761,24.761,0,0,0-2149.01,410.948Z",
    transform: "translate(2196.762 -388.524)",
    fill: "#d13627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161579",
    "data-name": "Path 161579",
    d: "M-2158.042,417a5.63,5.63,0,0,0-2.6-2.2c-.278-2.62-1.046-5.221-2.543-6.26,1.9-.354,3.871,1.651,4.571,4.487.12-.943.236-1.881.356-2.818.353-.1.626.5.561,1.065q.823-2.251,1.643-4.511a5.9,5.9,0,0,1,4.321,2.832,13.761,13.761,0,0,1,2.136,6.6,13.554,13.554,0,0,0-1.319-3.464c-.664-1.373-1.635-2.472-2.723-2.58s-2.252.975-2.484,2.66c-.258,1.851.53,4.149-.3,5.5-.353-1.131-.708-2.258-1.059-3.386A12.211,12.211,0,0,0-2158.042,417Z",
    transform: "translate(2197.761 -387.949)",
    fill: "#ee4823"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161580",
    "data-name": "Path 161580",
    d: "M-2192.428,377.2s-12.532,1.7-10.661,6.35,71.647,36.588,71.647,36.588l-19.106,25.379s-44.351-23.94-54.988-44.117l.683-18.7S-2204.781,377.2-2192.428,377.2Z",
    transform: "translate(2318.306 -203.774)",
    fill: "#abafb8"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87739",
    "data-name": "Group 87739",
    transform: "translate(78.476 228.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87738",
    "data-name": "Group 87738",
    transform: "translate(28.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161581",
    "data-name": "Path 161581",
    d: "M-2187.382,437.224s.892-.682,2.113,3.454,6.116,32.021,3.716,33.4-7.949-1.417-7.949-1.417-4.773-7.061-4.829-9.006-3.544-8.005-2.452-10.831,2.588-7.805,2.716-7.983,1.4-2.468,1.737-3.222A42.07,42.07,0,0,1-2187.382,437.224Z",
    transform: "translate(2220.132 -372.15)",
    fill: "#7b7d8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87737",
    "data-name": "Group 87737",
    transform: "translate(19.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161582",
    "data-name": "Path 161582",
    d: "M-2183,437.852s.674-.484,1.5,2.6,3.889,23.868,2.082,24.84-5.864-1.215-5.864-1.215-3.4-5.333-3.4-6.782-2.468-6-1.6-8.083,2.08-5.73,2.175-5.862,1.091-1.8,1.353-2.352A31.1,31.1,0,0,1-2183,437.852Z",
    transform: "translate(2207.377 -371.507)",
    fill: "#7b7d8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87736",
    "data-name": "Group 87736",
    transform: "translate(10.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161583",
    "data-name": "Path 161583",
    d: "M-2170.964,436.029l-3.96,4.8a122.875,122.875,0,0,1-18.758,2.554q2.276,11.966,4.389,23.962c13.307-2.69,30.02-6.4,33.876-8.806Z",
    transform: "translate(2193.683 -373.304)",
    fill: "#f0ab7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87735",
    "data-name": "Group 87735",
    transform: "translate(12.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161584",
    "data-name": "Path 161584",
    d: "M-2185.382,439.9a53.064,53.064,0,0,0,11.686,20.467c-3.8-4.1-5.688-20.888-7.854-22.965C-2182.36,437.562-2184.123,439.692-2185.382,439.9Z",
    transform: "translate(2189.25 -371.928)",
    fill: "#e98047"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87734",
    "data-name": "Group 87734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87731",
    "data-name": "Group 87731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161585",
    "data-name": "Path 161585",
    d: "M-2180.313,467.282s-4.044-15.81-1.314-24.026-.283-16.925-1.059-20.565-8.838-18-1.7-18c3.35,0,14.822-.584,14.1,13.409s-2.9,17.429,3.482,17.479,14.183-.738,15.847,12.88",
    transform: "translate(2187.315 -404.687)",
    fill: "#f0ab7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161586",
    "data-name": "Path 161586",
    d: "M-2183.736,419.676s12.238,4.245,8.286-12.42c0,0,4.076,5.9-.389,17.153C-2179.316,433.175-2183.736,419.676-2183.736,419.676Z",
    transform: "translate(2190.897 -402.115)",
    fill: "#e98047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87733",
    "data-name": "Group 87733",
    transform: "translate(6.119 31.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161587",
    "data-name": "Path 161587",
    d: "M-2180.651,426.735s17.538-9.932,26.157-4.6a21.421,21.421,0,0,1,3.3,7.869s6.19,6.618,3.477,12.67c0,0,2.766,8.808-.747,12.408,0,0,1.861,8.267-2.7,13.729,0,0-7.843,5.269-13.467,4.919,0,0-5.39,3.5-9.11,2.79a51.833,51.833,0,0,1-9.955-30.33S-2186.186,432.625-2180.651,426.735Z",
    transform: "translate(2184.257 -420.561)",
    fill: "#f0ab7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87732",
    "data-name": "Group 87732",
    transform: "translate(11.23 8.72)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161588",
    "data-name": "Path 161588",
    d: "M-2178.1,432.623l-.55-1.317c.6-.262,14.7-6.348,21.824-6.388l.01,1.429C-2163.656,426.393-2177.948,432.563-2178.1,432.623Z",
    transform: "translate(2178.646 -424.918)",
    fill: "#e98047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161589",
    "data-name": "Path 161589",
    d: "M-2176.652,440.835l-.548-1.317c.708-.31,17.532-7.593,22.311-8.263l.2,1.419C-2159.292,433.318-2176.474,440.761-2176.652,440.835Z",
    transform: "translate(2180.094 -418.573)",
    fill: "#e98047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161590",
    "data-name": "Path 161590",
    d: "M-2175.309,447.213l-.646-1.269c.6-.314,14.728-7.785,19.071-8.486l.218,1.417C-2160.779,439.544-2175.161,447.139-2175.309,447.213Z",
    transform: "translate(2181.341 -412.361)",
    fill: "#e98047"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_161591",
    "data-name": "Path 161591",
    d: "M-2184.793,434.049s1.849-12.12,26.091-13.251C-2158.7,420.8-2184.945,419.311-2184.793,434.049Z",
    transform: "translate(2189.839 -388.597)",
    fill: "#e98047"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_161592",
    "data-name": "Path 161592",
    d: "M-2189.488,475.966a94.773,94.773,0,0,0,18.524-10.681s-9.645-16.459-3.577-27.448a96.96,96.96,0,0,1-24.374,2.942C-2196.13,452.613-2193.114,464.362-2189.488,475.966Z",
    transform: "translate(2198.92 -371.494)",
    fill: "#8f919b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161593",
    "data-name": "Path 161593",
    d: "M-2196.8,449.549a209.992,209.992,0,0,1,21.86-10.9c.128-.272.26-.546.4-.813a96.96,96.96,0,0,1-24.374,2.942Q-2197.878,445.168-2196.8,449.549Z",
    transform: "translate(2198.917 -371.494)",
    fill: "#7b7d8e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161594",
    "data-name": "Path 161594",
    d: "M-2197.27,488.757c15.092-5.243,18.128-5.878,27.288-14.7,0,0-13.609-21.814-5.83-36.854a131.061,131.061,0,0,1-32.743,4.889C-2204.371,457.937-2202.575,473.255-2197.27,488.757Z",
    transform: "translate(2208.555 -372.127)",
    fill: "#e2ebf2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161595",
    "data-name": "Path 161595",
    d: "M-2163.233,437.681s-40.336,8.664-59.439-.5C-2222.664,437.181-2206.4,448.821-2163.233,437.681Z",
    transform: "translate(2222.672 -372.151)",
    fill: "#abafb8"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161596",
    "data-name": "Path 161596",
    d: "M-2137.065,393.314s-3.522,7.4-16.425,13.7l9.168,17.271S-2135.726,403.665-2137.065,393.314Z",
    transform: "translate(2370.421 -187.641)",
    fill: "#abafb8"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87969",
    "data-name": "Group 87969",
    transform: "translate(0.003 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162524",
    "data-name": "Path 162524",
    d: "M-1848.885,487.885l-.01,0v0l-.016.006a1.532,1.532,0,0,0-.557.144c-3.744,1.4-9.928,14.235-12.968,20.988v0l-.472.022c2.912-11.966,3.082-20.117-.458-19.611-2.61.372-5.618,6.264-7.387,12.912.573-5.129,2.562-15.47-1.931-15.24-4.8.252-5.654,8.175-7.383,21.1a8.106,8.106,0,0,1-2.734,3.682,11.742,11.742,0,0,1-4.983.985,25.45,25.45,0,0,1-9.967-2.506,7.536,7.536,0,0,0,.608-3.7,15.5,15.5,0,0,0-2.631-8.542c-1.261-1.553-5.99-3.2-7.273-2.424-1.183.708.911,4.457.911,4.457,1.5,7.921-7.181,10.663-10.475,12.644s-2.093,4.569-1.345,9.748a4.35,4.35,0,0,1,.116,1.141c-1.02-.582-1.839-1.029-2.279-1.231-2.854-1.311-2.924-.488-2.924-.48l0,0c-1.148,2.45-2.432,4.829-3.772,7.173-3.136-1.317-3.248-.372-3.248-.372v.012a139.544,139.544,0,0,1-27.376,38.845l-.09-.1c-.493-.556-1-1.1-1.519-1.627a31.036,31.036,0,0,0-5.592-4.763c-4.671-2.854-25.853-29.822-34.266-43.46a31.127,31.127,0,0,0-13.679-11.918c-2.4-2.8-6.633-5.2-15.809-7.363a18.136,18.136,0,0,0-.138-2.2v0c.022-.412.044-.877.062-1.417l-.022.038a111.467,111.467,0,0,0-.287-14.688,31.377,31.377,0,0,0-2.53-8.93,9.908,9.908,0,0,0,4.733.108,8.842,8.842,0,0,0,2.488-.786c5.166-2.522,6.068-9.412,6.068-9.412l-.018.02,0-.012a1.633,1.633,0,0,1-.918.713,4.367,4.367,0,0,1-2.292-.04c-.188-.048-.32-.09-.322-.09,2.153-1.707,2.359-6.378,2.361-8.069,0-.39-.01-.622-.01-.622l-1.763,1.2h0a3.828,3.828,0,0,0,.168-1.015c0-.07.01-.138.01-.21a5.023,5.023,0,0,0-.1-.987c-.014-.068-.032-.136-.05-.206a6.973,6.973,0,0,0-.282-.921l-.036-.108a10,10,0,0,0-.45-.951c-.038-.074-.076-.146-.118-.218-.164-.294-.336-.58-.517-.851-.038-.058-.076-.11-.114-.166-.162-.238-.327-.464-.489-.677-.034-.048-.068-.094-.1-.14-.176-.224-.344-.428-.5-.614l-.148-.172c-.136-.154-.262-.3-.37-.412l-.038-.042,0,0c-.243-.26-.4-.41-.4-.41a11.932,11.932,0,0,1-.887,6.9l-2.062-1.8c-.588,5.1-4.121,2.7-4.121,2.7a58.3,58.3,0,0,0-6.758-3.148c8.653-9.572,13.3-30.028,2.708-33.444a20.129,20.129,0,0,0-12.6-.272c-4.007,1.161-7.855,3.222-13.006,4.705a32.186,32.186,0,0,1-2.248-3.843c.25-.092.4-.152.4-.152-.108.022-.216.034-.324.054l-.016-.04a17.153,17.153,0,0,0-1.329-2.562c-1.086-2.5-1.987-4.949-2.651-6.77a26.245,26.245,0,0,0-2.348-4.335c2.562.168,5.018.54,6.061,1.327a4.7,4.7,0,0,0-2.8-4.175q-2.793-.486-5.618-.695c-1.128-1.633-2.287-3.236-3.3-4.609a4.018,4.018,0,0,0,1.489-3.016,10.121,10.121,0,0,0-2.684-6.88,19.132,19.132,0,0,0-5.406-2.764c2.286-3.03,1.191-6.436-1.865-8.65a17.178,17.178,0,0,0-7.527-2.412c-.29-.971-.638-1.919-.918-2.8-1.024-3.266-18.814-18.924-19.487-20.924-.626-1.915-1.311-3.808-2.029-5.69a22.456,22.456,0,0,0,4.75.745,22.918,22.918,0,0,0,23.4-22.453v-.04a23.1,23.1,0,0,0-19.617-24c-.44-.068-.893-.094-1.341-.134-.264-.022-.521-.064-.789-.078h0l-.048,0a20.887,20.887,0,0,0-2.244.056,22.553,22.553,0,0,0-15.08,7.4,24.475,24.475,0,0,0-20.782-13.781l-.028,0-.018,0a23.21,23.21,0,0,0-2.394.054,24.637,24.637,0,0,0-22.669,24.032v.046a25.166,25.166,0,0,0,1.425,9.54,23,23,0,0,0-19.033,22.14l0,.044a23.064,23.064,0,0,0,21.747,24.212,22.5,22.5,0,0,0,16.8-6.859c2.94,1.841,1.037,27.168,4.971,31.262a17.768,17.768,0,0,0-1.429,2.332,6.942,6.942,0,0,0,1.555,8.047,7,7,0,0,0,.819,8.838,10.13,10.13,0,0,0,8.4,2.468v10.979a5.34,5.34,0,0,0-3.46.915c-6.727,4.321-9.056,18.984,4.479,27.448l-1.591,7.921c-12.352,0-12.426,5.5-12.426,5.5l-.681,18.694c-6.752,3.734-14.145,7.841-19.135,10.657h0c-1.877,1.059-3.4,1.931-4.435,2.536l-.122.07c-.184.108-.35.206-.5.3l-.1.058c-.164.1-.308.188-.418.258-.168.106-.349.2-.526.3-.068.038-.134.08-.2.116-.44.232-.913.446-1.4.662-3.719,1.633-8.806,3.372-14.226,14.145-6.542,13.006-16.511,32.041-19.314,36.64-.595.979-2.507,4.949-4.914,10.709q-2.272,5.325-4.23,10.775c-.167.452-.334.917-.5,1.377-.052.146-.1.29-.158.436-.777,2.159-1.551,4.4-2.308,6.71l-.022.068q-.546,1.66-1.071,3.358c-.04.124-.078.248-.116.374-1.094,3.54-2.12,7.177-3.018,10.833-.03.122-.06.244-.09.368q-.423,1.738-.8,3.474l-.032.144c-.535,2.448-1,4.883-1.377,7.287-.02.12-.038.242-.056.364q-.249,1.606-.44,3.188c-.016.134-.034.268-.05.4-.272,2.326-.45,4.6-.514,6.795,0,.114,0,.226-.006.34-.024.959-.022,1.9,0,2.824,0,.176.008.35.014.524.034,1,.09,1.987.184,2.944l0,.044q.15,1.522.406,2.956c.014.084.034.164.05.248q.229,1.228.542,2.382c.05.182.1.362.152.54q.316,1.084.712,2.093c.048.12.088.244.138.362a20.122,20.122,0,0,0,1.1,2.278c.018.032.04.06.058.092a17.247,17.247,0,0,0,1.245,1.851c.118.152.24.3.362.444a15.018,15.018,0,0,0,1.251,1.343c.134.128.262.26.4.382a14.688,14.688,0,0,0,1.872,1.429c1.235.795,2.5,1.529,3.791,2.234.208.116.42.236.628.348.336.178.676.352,1.015.526.568.29,1.127.568,1.677.829.132.064.265.126.4.188.75.35,1.487.677,2.206.973.062.026.124.056.188.082h0a41.305,41.305,0,0,0,8.556,2.522c10.907,1.885,16.347-2.666,16.437-2.742l-.084,1.877-.006,0-1.227,27.252c-15.424-6.366-21.07-7.393-18.2-1.721-.455.106-.929.218-1.413.334-.148.036-.294.07-.447.108-.608.146-1.239.3-1.887.464l-.4.1q-1.078.27-2.215.572l-.22.056c-2.552.676-5.306,1.455-8.171,2.339l-.333.1q-1.219.378-2.458.783c-.248.08-.5.166-.749.248-.7.23-1.4.464-2.1.708-.306.106-.612.214-.918.322-.656.23-1.311.464-1.969.7-.224.084-.448.164-.672.248l0,0c-.142.054-.282.112-.424.164-.6.226-1.2.454-1.8.689-.228.09-.458.176-.684.266-.138.054-.274.112-.412.168-.6.24-1.193.484-1.789.734-.256.106-.513.208-.769.318-.086.036-.172.076-.258.114l-.046.02c-.6.258-1.2.524-1.8.793-.349.158-.7.312-1.045.472-.614.284-1.221.578-1.823.873-.317.152-.635.3-.947.458-.67.336-1.325.682-1.978,1.031-.236.124-.477.244-.708.372q-1.318.717-2.582,1.471c-.1.06-.192.124-.292.184-.728.442-1.443.891-2.137,1.349-.274.182-.532.372-.8.558-.5.344-1,.691-1.483,1.045-.3.224-.586.456-.88.685-.42.326-.838.654-1.237.989-.3.25-.582.506-.869.763-.366.326-.727.652-1.07.985-.034.034-.07.064-.1.1l-.04.038c-.23.224-.442.454-.663.68-.32.334-.632.67-.931,1.011-.02.022-.042.044-.062.068-.038.042-.08.082-.116.124-.188.22-.362.442-.542.662-.276.344-.538.692-.792,1.045l-.03.042c-.054.072-.114.142-.164.216-.146.208-.284.42-.422.63-.234.36-.444.727-.652,1.093l-.008.014c-.058.1-.128.2-.185.306-.106.2-.208.392-.306.59-.188.378-.344.765-.5,1.151-.052.13-.118.256-.168.386-.068.178-.14.356-.2.538-.138.4-.236.811-.34,1.221-.04.15-.09.3-.124.45s-.084.314-.114.474c-.082.432-.116.875-.162,1.315-.012.124-.046.242-.056.366l.01.054c0,.062-.018.124-.022.186-.006.1-.03.188-.034.284-.05,1.239-.032,2.422.02,3.578.008.162.012.328.02.49.066,1.1.178,2.159.33,3.184.026.166.054.328.08.492.173,1.037.378,2.043.637,3,.012.048.028.094.042.142a27.719,27.719,0,0,0,.937,2.836c.016.04.03.084.046.124a25.853,25.853,0,0,0,1.2,2.588c.038.074.078.148.118.222a24.558,24.558,0,0,0,1.447,2.354l.024.034c6.917,9.876,19.711,12.394,29.159,8.656,5.692-2.251,12.845-9.742,19.423-18.254-5.818,25.889-12,60.46-11.748,89.607h14.049s2.348-36.736,7.259-71.631q.237-1.687.482-3.366c.062-.424.126-.844.188-1.267.124-.841.252-1.679.378-2.516.064-.408.124-.819.188-1.227q.246-1.591.5-3.166.114-.717.232-1.433.21-1.267.422-2.522c.1-.566.192-1.127.29-1.687q.207-1.186.416-2.354l.1-.574c-1.013,13.873-1.9,31.07-1.927,49.138q0,1.6,0,3.214.012,2.735.048,5.49.051,3.63.156,7.275.063,2.177.145,4.351a331.554,331.554,0,0,0,3.644,39.558q.229,1.411.468,2.8l2.7-.46v0l.142-.024c2.121,14.393,4.945,30.508,8.692,47.339-.905,14.455-1.257,24.644-.221,26.942l.02.04a.975.975,0,0,0,.292.4,26.757,26.757,0,0,0,4.509,1.783q1.486.537,2.994,1.011,1.54,5.431,3.22,10.863l-.006,0a333.441,333.441,0,0,0,11.147,31.523c.1.254.2.508.308.762.384.931.76,1.863,1.153,2.79a284.632,284.632,0,0,0,15.35,31.543c.088.16.17.322.258.48l.006-.01q3.629,6.331,7.585,12.3h34.889s23.644-24.5,40.442-66.6l.03-.032c.1-.26.2-.524.3-.785.632-1.6,1.249-3.242,1.859-4.9.2-.538.418-1.071.613-1.609q1.4-.12,2.838-.272c1.507,3.963,3.108,7.887,4.775,11.782a261.011,261.011,0,0,0,22.632,42.944c-.07.062-12.638,11.443-2.7,20.936,0,0,.831,5.5,1.455,5.5h18.065s1.249.847,2.492-5.283c0,0,6.438,1.137,8.308,5.323,0,0,43.4,9.982,61.262,0l-53.988-26.471c.064-.066,17.042-17.7,32.434-48.688l.022-.012c.254-.514.5-1.035.749-1.551.382-.782.761-1.563,1.141-2.362q.727-1.534,1.429-3.078c.314-.684.626-1.365.937-2.061.5-1.121.985-2.25,1.469-3.378.286-.671.576-1.335.86-2.015.486-1.171.957-2.346,1.425-3.524.274-.689.554-1.365.825-2.063q1.021-2.636,1.981-5.3c.347-.965.681-1.957,1.019-2.94.312-.9.628-1.8.928-2.706.252-.758.5-1.525.745-2.293.471-.358.92-.742,1.407-1.075.08-.056.16-.112.24-.166a33.63,33.63,0,0,1,5.494-2.934c-.633,3.811.066,7.173,4.663,6.88,9.248-.586,8.518-6.272,8.27-7.437l.014.01s4.152-93.9-2.074-125.622-7.895-57.524-6.23-68.095c1.619-10.3,6.344-16.591-4.947-20.423l0-.026c-.274-.092-.553-.184-.847-.27a79.007,79.007,0,0,0-.974-11.377c-.477-2.822-1.063-5.732-1.722-8.69.955-1.461,2.071-3.2,3.316-5.183l.032-.052q.754-1.2,1.563-2.518l.1-.166c.18-.292.356-.576.54-.877l0-.006c13.006-21.3,35.533-63.073,37.3-99.461l0,0,0-.01c.088-.442-.472-1.2-1.475-2.151.488-3.1.858-6.224,1.048-9.364.138-.68-1.767-2.348-4.447-4.3a11.211,11.211,0,0,1,1.874-1.991c3.142-2.436,21.988-2.44,27.972-2.286s6.132-3.5,6.132-3.5c12.858-1.981,16.839-14.568,17.348-15.69C-1847.34,500.558-1845.012,487.885-1848.885,487.885Zm-209.859,35.879-.254-.262.491-.084C-2058.592,523.525-2058.667,523.649-2058.744,523.765Zm-164.428,191.011,0,0c-8.634,4.709-13.929,3.132-15.843,2.213-.172-2.364.048-4.593,1.051-6.126,2.826-4.313,30.27-20.862,38.421-25.717-.316,1.115-.7,2.474-1.13,4.053C-2205.71,696.892-2215.377,710.531-2223.172,714.776Z",
    transform: "translate(2261.883 -290.546)",
    fill: "#1b100e"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161533-2",
    "data-name": "Path 161533",
    d: "M-2146.8,377.184c11.766-2.876,15.41,9.548,15.41,9.548-19.362-.364-41.273,12.108-41.273,12.108C-2167.1,389.69-2153.279,378.765-2146.8,377.184Z",
    transform: "translate(2356.603 -206.048)",
    fill: "#ae2824"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161534-2",
    "data-name": "Path 161534",
    d: "M-2161.836,385.616a56.24,56.24,0,0,0-10.825,12.174s21.908-12.474,41.271-12.11a16.654,16.654,0,0,0-5.492-7.879q-11.887,3.275-23.527,7.313C-2160.886,385.278-2161.362,385.45-2161.836,385.616Z",
    transform: "translate(2356.603 -204.998)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "blink",
    transform: "translate(-2098.539 411.551)",
    style: {
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87740",
    "data-name": "Group 87740",
    transform: "translate(0 1.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161597",
    "data-name": "Path 161597",
    d: "M-2180.265,361.72s3.066-9.344,8.3-9.728a9.158,9.158,0,0,1,8.005,4.379s1.553,7.831-3.757,7.947A27.661,27.661,0,0,1-2180.265,361.72Z",
    transform: "translate(2180.265 -351.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161598",
    "data-name": "Path 161598",
    d: "M-2180.265,361.72s3.066-9.344,8.3-9.728a9.158,9.158,0,0,1,8.005,4.379,6.6,6.6,0,0,0-6.367-2.436C-2176.195,354.55-2176.408,358.55-2180.265,361.72Z",
    transform: "translate(2180.265 -351.99)",
    fill: "#1b100e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10589",
    "data-name": "Ellipse 10589",
    cx: 3.296,
    cy: 2.844,
    rx: 3.296,
    ry: 2.844,
    transform: "translate(4.052 9.197) rotate(-76)",
    fill: "#1b100e"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87741",
    "data-name": "Group 87741",
    transform: "translate(24.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161599",
    "data-name": "Path 161599",
    d: "M-2168.194,353.516s-.028.238-.034.61c-.02,1.123.269,4.073,1.826,4.687,2.059.818,9.236-1.479,9.236-1.479s-2.662-6.939-6.895-6.282S-2168.194,353.516-2168.194,353.516Z",
    transform: "translate(2168.299 -351.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10590",
    "data-name": "Ellipse 10590",
    cx: 2.069,
    cy: 2.65,
    rx: 2.069,
    ry: 2.65,
    transform: "translate(0.47 2.892) rotate(-14)",
    fill: "#1b100e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161600",
    "data-name": "Path 161600",
    d: "M-2168.16,353.517s-.208.935-.034.608a4.911,4.911,0,0,1,5.328-2.153c3.086.258,5.732,5.35,5.732,5.35s-2.66-6.927-6.893-6.268S-2168.16,353.517-2168.16,353.517Z",
    transform: "translate(2168.264 -351.007)",
    fill: "#1b100e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerBurned);
export default __webpack_public_path__ + "static/media/manager-burned.4873432642d49aa9f2218ddc575ead81.svg";
export { ForwardRef as ReactComponent };